module.exports = __webpack_public_path__ + "img/FXView-logo.64a6bfa8.svg";